<template>
  <settings-screen title="Backup - Google Drive">
    <div
        v-if="!isReady"
        class="centered-container">
      <h2>
        Loading...
      </h2>
    </div>
    <div
        v-if="isReady && isSignedIn"
        class="container">
      <google-user-banner/>
      <div class="toolbar">
        <h3>Backups</h3>
        <base-button
            text="Create Backup"
            @click="showCreateModal"/>
      </div>
      <google-backup-table
          :restoreBackup="showRestoreModal"
          :deleteBackup="showDeleteModal"/>
    </div>
    <div
        v-if="isReady && !isSignedIn"
        class="centered-container">
      <h2>Sign in with Google to enable Google Drive integration</h2>
      <google-sign-in-button
          @click="$store.dispatch('googleDriveBackup/signIn')"/>
    </div>
  </settings-screen>
</template>

<script>
import { mapState } from 'vuex';

import BaseButton from '@/components/core/BaseButton.vue';
import GoogleBackupTable from '@/components/settings/backup/googleDrive/GoogleBackupTable.vue';
import GoogleSignInButton from '@/components/settings/backup/googleDrive/GoogleSignInButton.vue';
import GoogleUserBanner from '@/components/settings/backup/googleDrive/GoogleUserBanner.vue';
import MessageModal from '@/components/core/modal/MessageModal.vue';
import SettingsScreen from '@/components/settings/SettingsScreen.vue';
import TextInputModal from '@/components/core/modal/TextInputModal.vue';

export default {
  name: 'GoogleDriveBackup',
  components: {
    BaseButton,
    GoogleBackupTable,
    GoogleSignInButton,
    GoogleUserBanner,
    SettingsScreen,
  },
  computed: {
    ...mapState({
      isReady: state => state.googleDriveBackup.isReady,
      isSignedIn: state => state.googleDriveBackup.isSignedIn,
      user: state => state.googleDriveBackup.user,

      backups: state => state.googleDriveBackup.backups,
      hasNextPage: state => state.googleDriveBackup.hasNextPage,
    }),
  },
  mounted() {
    this.$store.dispatch('googleDriveBackup/init');
  },
  methods: {
    async createBackup(name) {
      await this.$store.dispatch('googleDriveBackup/createBackup', {
        name,
      });

      this.$modal.dismiss();
    },
    async restoreBackup(backup) {
      await this.$store.dispatch('googleDriveBackup/restoreBackup', {
        backup,
      });

      this.$modal.dismiss();
    },
    async deleteBackup(backup) {
      await this.$store.dispatch('googleDriveBackup/deleteBackup', {
        fileId: backup.fileId,
      });

      this.$modal.dismiss();
    },
    showCreateModal() {
      this.$modal.show({
        component: TextInputModal,
        properties: {
          icon: 'backup',
          title: 'Create Backup',
          placeholder: 'Name',
          onSubmit: this.createBackup,
          buttons: [
            {
              text: 'Cancel',
              func: () => { this.$modal.dismiss(); },
            },
            {
              text: 'Create',
              func: this.createBackup,
            },
          ],
        },
      });
    },
    async showRestoreModal(backup) {
      this.$modal.show({
        component: MessageModal,
        properties: {
          icon: 'restore',
          title: 'Restore Backup',
          message: 'Are you sure you want to restore the backup?<br>This will overwrite all of your current notes.',
          buttons: [
            {
              text: 'Cancel',
              func: this.$modal.dismiss,
            },
            {
              text: 'Restore',
              func: async () => { await this.restoreBackup(backup); },
            },
          ],
        },
      });
    },
    showDeleteModal(backup) {
      this.$modal.show({
        component: MessageModal,
        properties: {
          icon: 'delete',
          title: 'Delete Backup',
          message: 'Are you sure you want to delete this backup?',
          buttons: [
            {
              text: 'No',
              func: this.$modal.dismiss,
            },
            {
              text: 'Yes',
              func: async () => { await this.deleteBackup(backup); },
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.centered-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: center;
  padding: 1rem;

  h2 {
    font-weight: normal;
  }

  button {
    margin-top: 1rem;
  }
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .toolbar {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;

    h3 {
      font-weight: 400;
    }

    button {
      margin: 0;
    }
  }
}
</style>
